import styled from 'styled-components';

export const SectionHeader = styled.div`
text-transform: uppercase;
font-size: 12px;
color: var(--orange);
letter-spacing: 2.4px;
padding-bottom: 26px;
font-weight: bold;
`;